(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cnm-product-recommendation-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.Swiper) {
    console.warn('[Product Recommendations Showcase] Swiper not found');
  }

  function buildConfig(root, panel) {
    var prevSel = panel.getAttribute('data-prev');
    var nextSel = panel.getAttribute('data-next');
    var scrollbarSel = panel.getAttribute('data-scrollbar');
    return {
      slidesPerView: 4.3,
      spaceBetween: 20,
      allowTouchMove: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      navigation: {
        nextEl: nextSel ? document.querySelector(nextSel) : null,
        prevEl: prevSel ? document.querySelector(prevSel) : null
      },
      scrollbar: {
        el: scrollbarSel ? document.querySelector(scrollbarSel) : null,
        draggable: true,
        hide: false,
        snapOnRelease: true
      },
      mousewheel: { forceToAxis: true },
      breakpoints: {
        0: { slidesPerView: 2, spaceBetween: 12 },
        480: { slidesPerView: 2, spaceBetween: 12 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        992: { slidesPerView: 4, spaceBetween: 16 },
        1920: { slidesPerView: 5, spaceBetween: 16 },
        2160: { slidesPerView: 6, spaceBetween: 16 }
      }
    };
  }

  function initGridToggle(root) {
    var btn = root.querySelector('.mh-cnm-prd-shwcase__load-more');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-load-more-for');
      if (!targetId) return;
      var panel = root.querySelector('#' + targetId);
      if (!panel) return;
      var gridInner = panel.querySelector('.mh-cnm-prd-shwcase-grid__inner');
      if (!gridInner) return;
      var initialCount = parseInt(gridInner.getAttribute('data-initial-count'), 10) || 0;
      var items = gridInner.querySelectorAll('.mh-cnm-prd-shwcase-grid__item');
      var isExpanded = btn.getAttribute('data-expanded') === '1';
      if (!isExpanded) {
        items.forEach(function (item) { item.removeAttribute('data-hidden'); item.style.display = ''; });
        btn.textContent = 'Show less products';
        btn.setAttribute('data-expanded', '1');
      } else {
        var visibleCount = 0;
        items.forEach(function (item) {
          visibleCount++;
          if (visibleCount > initialCount && initialCount > 0) {
            item.setAttribute('data-hidden', '1'); item.style.display = 'none';
          } else {
            item.removeAttribute('data-hidden'); item.style.display = '';
          }
        });
        btn.textContent = 'Show more products';
        btn.setAttribute('data-expanded', '0');
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initOne(root) {
    if (!root) return;
    var layout = root.getAttribute('data-layout') || 'carousel';
    var host = root.querySelector('.mh-cnm-prd-shwcase-host');
    if (!host) return;

    function tryInit() {
      var panel = root.querySelector('.mh-cnm-prd-shwcase-crsl, .mh-cnm-prd-shwcase-grid');
      if (!panel || panel.__mh_reco_inited) return;

      if (layout === 'carousel' && window.Swiper) {
        var cfg = buildConfig(root, panel);
        try { new Swiper(panel, cfg); } catch (e) {
          console.warn('[Product Recommendations Showcase] Swiper init failed', e);
        }
      }
      if (layout === 'grid') { initGridToggle(root); }
      panel.__mh_reco_inited = true;
    }

    var mo = new MutationObserver(function(mutations, observer) {
      var panel = root.querySelector('.mh-cnm-prd-shwcase-crsl, .mh-cnm-prd-shwcase-grid');
      if (!panel) return;

      observer.disconnect();

      host.querySelectorAll('script').forEach(function(oldScript) {
        var newScript = document.createElement('script');
        newScript.textContent = oldScript.textContent;
        document.head.appendChild(newScript);
        oldScript.remove();
      });

      tryInit();
    });

    mo.observe(host, { childList: true, subtree: true });
    tryInit();
  }

  function initAll() {
    document.querySelectorAll('.mh-cnm-prd-shwcase-wrpr').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sectionId = e && e.detail && e.detail.sectionId;
    var container = document.getElementById('shopify-section-' + sectionId);
    if (!container) return;
    container.querySelectorAll('.mh-cnm-prd-shwcase-wrpr').forEach(initOne);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return; // safety: bail if header missing

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window
      .matchMedia('(max-width: 990px)')
      .addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    if (!this.header) return;
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    if (!this.header) return;

    let observer = new IntersectionObserver((entries, observerInstance) => {
      this.headerBounds = entries[0].intersectionRect;
      observerInstance.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    if (!this.headerBounds) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    if (!this.header) return;
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    if (!this.disclosures || !this.disclosures.length) return;

    this.disclosures.forEach((disclosure) => {
      if (disclosure && typeof disclosure.close === 'function') {
        disclosure.close();
      }
    });
  }

  closeSearchModal() {
    if (!this.header) return;
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');

    // If search modal was removed from the header, just skip quietly
    if (!this.searchModal || typeof this.searchModal.close !== 'function') {
      return;
    }

    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
